import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  root: {},
  actions: {
    justifyContent: 'space-between',
  },
}));
